// Shim cross-fetch to use native browser fetch
// Resolves: "Illegal invocation" error from cross-fetch losing window context in webpack bundle

const fetchShim = window.fetch.bind(window);
fetchShim.Headers = window.Headers;
fetchShim.Request = window.Request;
fetchShim.Response = window.Response;

export default fetchShim;
export const { Headers, Request, Response } = window;
export { fetchShim as fetch };
